import { render } from "./Home.vue?vue&type=template&id=7b0eda8c"
import script from "./Home.js?vue&type=script&lang=js"
export * from "./Home.js?vue&type=script&lang=js"

import "./Home.scss?vue&type=style&index=0&lang=scss"
/* custom blocks */
import block0 from "./Home.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fpresentation%2Ffashion%2FHome%2FHome.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__